export const API_BASE_URL = 'https://mdscresoft-group.com/api'; 